import { render } from "./EditRole.vue?vue&type=template&id=7acb9517&scoped=true"
import script from "./EditRole.vue?vue&type=script&lang=js"
export * from "./EditRole.vue?vue&type=script&lang=js"

import "./EditRole.vue?vue&type=style&index=0&id=7acb9517&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7acb9517"]])

export default __exports__